import { useCallback, useEffect } from 'react';
import { ConfirmPopup, Text } from '~/commonComponents';
import AnimatedCheckCircle from '~/components/shared/AnimatedCheckCircle';
import { CandidateStatus, useUpdateCandidateStatus } from '~/domain/PermanentJobs';
import { IToggleControls } from '~/hooks/useToggle';
import { Colors } from '~/themes/colors';

interface IProps {
  controls: IToggleControls;
  professionalId: string;
  professionalName: string;
}

export const HirePopupConfirmation = ({ controls, professionalId, professionalName }: IProps) => {
  const { isError, isPending, isSuccess, mutate, reset } = useUpdateCandidateStatus();

  const handleConfirmHireCandidate = () =>
    mutate({ candidateIds: [professionalId], status: CandidateStatus.Hired });

  const handleClosePopup = useCallback(() => {
    reset();
    controls.setOff();
  }, [controls, reset]);

  useEffect(() => {
    if (isError) {
      handleClosePopup();
    }
  }, [handleClosePopup, isError]);

  return (
    <>
      {!isSuccess ? (
        // @ts-expect-error - ConfirmPopup still written in JavaScript
        <ConfirmPopup
          title="Mark Candidate as Hired"
          description={
            <Text color={Colors.neutral_500}>
              You’re about to mark{' '}
              <Text bold color={Colors.neutral_500}>
                {professionalName}
              </Text>{' '}
              as Hired for this
              <br />
              position. A confirmation message will be sent to the
              <br />
              candidate. This job will remain open for additional
              <br />
              applicants until its status is set to Closed.
            </Text>
          }
          descriptionStyle={{ width: '100%', marginBottom: 38 }}
          modalStyle={{ width: 560 }}
          leftButtonAction={handleClosePopup}
          leftButtonDisabled={isPending}
          leftButtonText="Go Back"
          rightButtonAction={handleConfirmHireCandidate}
          rightButtonLoading={isPending}
          rightButtonText="Confirm"
        />
      ) : (
        // @ts-expect-error - ConfirmPopup still written in JavaScript
        <ConfirmPopup
          Icon={() => <AnimatedCheckCircle />}
          title="Congratulations on Your Hire!"
          titleStyle={{ marginTop: 21, marginBottom: 16 }}
          description={
            <Text color={Colors.neutral_500}>
              The candidate’s status has been updated and moved to
              <br />
              the Hired tab. We’re glad GoTu helped you find the
              <br />
              right professional for your team.
            </Text>
          }
          descriptionStyle={{ width: '100%', marginBottom: 38 }}
          modalStyle={{ width: 560 }}
          rightButtonText="Done"
          rightButtonAction={handleClosePopup}
        />
      )}
    </>
  );
};
